<template>
    <div>
        <div class="h1 mt-5 container">
            Domande Frequenti
        </div>
        <div class="mt-3 container pt-5 pb-5">
            <div class="h2">
                Il servizio ha un costo?
            </div>
            <hr/>
            <div>
                L'iscrizione online è totalmente gratuita.
            </div>
        </div>
        <div class="mt-3 bg-light text-black pt-5 pb-5">
            <div class="container">
                <div class="h2">
                    Perché registrarsi?
                </div>
                <hr/>
                <div>
                    Il servizio è stato pensato per sfruttare le potenzialità di rete di aziende della Valle di Comino. 
                    Studiamo la storia e la tradizione del territorio per garantire l'efficacia al servizio e permetterti di non dover pensare alla promozione online. 
                    Non vi sono particolari vincoli, puoi registrarti oppure cancellarti, gratuitamente.
                </div>
            </div>
        </div>
        <div class="mt-3 container pt-5 pb-5">
            <div class="h2">
                Quali sono i servizi sono offerti?
            </div>
            <hr/>
            <div>
                La piattaforma offre due servizi online: per l'azienda offre la possibilità di registrarsi posizionandosi <a href="/registrati"></a> sulla mappa, per
                per il cliente la possibilità di <a href="/mappa">ricercare un negozio.</a>
            </div>
        </div>
        <div class="mt-3 bg-light text-black pt-5 pb-5">
            <div class="container">
                <div class="h2">
                    Cos’è un canale digitale di comunicazione?
                </div>
                <hr/>
                <div>
                    Un canale digitale è qualunque mezzo con cui il cliente e negoziante possono entrare in contatto facilmente, per esempio il tuo Whatsapp, il tuo Telegram, il numero di telefono, il tuo profilo Facebook, o la tua email.
                </div>
            </div>
        </div>
        <div class="mt-3 pt-5 pb-5">
            <div class="container">
                <div class="h2">
                    Che tipo di negozi posso trovare?
                </div>
                <hr/>
                <div>
                    Sulla piattaforma cerchiamo di presentare tutti i tipi di piccole e medie aziende suddivise in categorie, esempi possono essere: Alimentari, Biologico, Vinicolo,
                    Cioccolateria, Enoteca, Formaggeria, Frutteria, Gastronomia, Macelleria, Oleoteca, Panificio,
                    Pasticceria, Pastificio, Pescheria, Torrefazione.
                </div>
            </div>
        </div>
        <div class="mt-3 bg-light text-black pt-5 pb-5">
            <div class="container">
                <div class="h2">
                    I miei dati sono al sicuro?
                </div>
                <hr/>
                <div>
                    Le uniche informazioni fornite sulla piattaforma sono quelle che vengono espressamente richieste e mostrate sulla mappa, non 
                    possediamo altre informazioni.
                </div>
            </div>
        </div>
        <div class="mt-3 pt-5 pb-5">
            <div class="container">
                <div class="h2">
                    Come faccio a cancellarmi?
                </div>
                <hr/>
                <div>
                    È sufficiente inviare una e-mail specificando la richiesta di cancellarsi.
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  export default {
    name: "Faq"
  }
</script>

<style scoped>

a, a:visited, a:hover {
    text-decoration: none;
    color: #2c3e50;
}

</style>
